var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 484 484",
    style: {
      enableBackground: "new 0 0 484 484"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D34302;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M428.2,19.5c-26-26-68.1-26-94.1,0l-23.6,23.7L59.7,293.8l-0.5,0.5c-0.1,0.1-0.1,0.3-0.3,0.3 c-0.3,0.4-0.7,0.8-0.9,1.2c0,0.1-0.1,0.1-0.1,0.3c-0.3,0.4-0.4,0.7-0.7,1.1c-0.1,0.1-0.1,0.3-0.3,0.4c-0.1,0.4-0.3,0.7-0.4,1.1 c0,0.1-0.1,0.1-0.1,0.3L0.7,466.2c-1.6,4.8-0.4,10,3.2,13.6c2.5,2.5,5.9,3.9,9.5,3.9c1.4,0,2.9-0.2,4.3-0.7l167.2-55.8 c0.1,0,0.1,0,0.3-0.1c0.4-0.1,0.8-0.3,1.2-0.5c0.1,0,0.2-0.1,0.3-0.1c0.4-0.3,0.9-0.5,1.3-0.8c0.4-0.3,0.8-0.7,1.2-0.9 c0.1-0.1,0.3-0.1,0.3-0.3c0.1-0.1,0.4-0.3,0.5-0.5l274.4-274.4c26-26,26-68.1,0-94.1L428.2,19.5z M180.6,395.9l-92.7-92.7 L319.8,71.4l92.7,92.7L180.6,395.9z M74.9,327.9l80.9,80.9L34.3,449.3L74.9,327.9z M445.5,130.9l-14.1,14.2l-92.7-92.7L353,38.2 c15.6-15.6,40.9-15.6,56.4,0l36.2,36.2C461.1,90.1,461,115.3,445.5,130.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.343c3020ff7f658c55808707e6046e6f.svg";
export { ForwardRef as ReactComponent };